export const ProductSortType = {
  PRODUCT_SORT_TYPE_INVALID: 0,
  POPULARITY_DESC: 1,
  RELEASE_DATE_DESC: 2,
  PRICE_ASC: 3,
  PRICE_DESC: 4,
  RELEASE_DATE_ASC: 8,
  DATE_ADDED_DESC: 9,
};

export const SPECIAL_DISPLAY_BRAND_NAMES: Record<string, string> = {
  adidas: 'adidas',
  'a.p.c.': 'A.P.C.',
  asics: 'ASICS',
  bape: 'BAPE',
  chloe: 'Chloé',
  'alexander mcqueen': 'Alexander McQueen',
  arcade: 'ARCADE',
  'off-white': 'OFF-WHITE',
  'comme des garcons': 'Comme des Garcons',
  '1017-alyx-9sm': '1017 ALYX 9SM',
  '1017 alyx 9sm': '1017 ALYX 9SM',
  'born-x-raised': 'Born x Raised',
  'born x raised': 'Born x Raised',
  'eckhaus-latta': 'ECKHAUS LATTA',
  'eckhaus latta': 'ECKHAUS LATTA',
  mcq: 'MCQ',
  'genesis-ii': 'Genesis II',
  't-shirts': 'T-Shirts',
};

export type TopTitleFilter =
  | 'productCategoriesList'
  | 'brandsList'
  | 'colorsList'
  | 'yearsList'
  | 'gendersList'
  | 'sizesList'
  | 'productConditionsList';

export const NAME_DISPLAY: Record<
  TopTitleFilter | 'sale' | 'instantShip' | 'underRetail' | 'inStock' | 'price',
  string
> = {
  brandsList: 'Brand',
  productCategoriesList: 'Category',
  gendersList: 'Gender',
  sizesList: 'Size',
  productConditionsList: 'Condition',
  colorsList: 'Color',
  price: 'Price',
  instantShip: 'Instant',
  underRetail: 'Under Retail',
  inStock: 'Available Now',
  sale: 'Sale',
  yearsList: 'Year',
};

export const QUERY_NAME_DISPLAY: Record<
  | TopTitleFilter
  | 'productTypesList'
  | 'activitiesList'
  | 'price'
  | 'sizesList'
  | 'productConditionsList'
  | 'inStock'
  | 'underRetail'
  | 'instantShip'
  | 'sale',
  string
> = {
  brandsList: 'brands',
  productCategoriesList: 'categories',
  productTypesList: 'types',
  activitiesList: 'activities',
  gendersList: 'genders',
  colorsList: 'colors',
  price: 'price',
  productConditionsList: 'conditions',
  yearsList: 'years',
  sizesList: 'size',
  underRetail: 'underRetail',
  inStock: 'inStock',
  sale: 'sale',
  instantShip: 'instantShip',
};

export const SORT_FILTER_MAP: any = {
  popular: {
    name: 'Popular',
    value: ProductSortType.POPULARITY_DESC,
    key: 'popular',
  },
  recently_released_sneakers: {
    name: 'Recently Released Sneakers',
    value: ProductSortType.RELEASE_DATE_DESC,
    key: 'recently_released_sneakers',
  },
  new_in_apparel: {
    name: 'New In Apparel',
    value: ProductSortType.DATE_ADDED_DESC,
    key: 'new_in_apparel',
  },
  price_low_high: {
    name: 'Price (Low - High)',
    value: ProductSortType.PRICE_ASC,
    key: 'price_low_high',
  },
  price_high_low: {
    name: 'Price (High - Low)',
    value: ProductSortType.PRICE_DESC,
    key: 'price_high_low',
  },
  new_in: {
    name: 'New In',
    value: ProductSortType.DATE_ADDED_DESC,
    key: 'new_in',
  },
  upcoming_releases: {
    name: 'Upcoming Releases',
    value: ProductSortType.RELEASE_DATE_ASC,
    key: 'upcoming_releases',
  },
  date: {
    name: 'Date',
    value: ProductSortType.RELEASE_DATE_ASC,
    key: 'date',
  },
};

export const HEADER_NAMES: any = {
  brandsList: {
    name: 'Brand',
    count: 'Items',
    location: 'Location',
  },
  productCategoriesList: {
    name: 'Category',
    count: 'Items',
  },
  colorsList: {
    name: 'Color',
    count: 'Items',
  },
  productConditionsList: {
    name: 'Condition',
    count: 'Items',
  },
};

export const CONDITION_DESCRIPTION = {
  new_no_defects: {
    display_name: 'new',
    data: { description: 'New and never worn items' },
  },
  used: { display_name: 'used', data: { description: 'Gently used or worn items' } },
  new_with_defects: {
    display_name: 'new With Defects',
    data: { description: 'New or unworn sneakers with imperfections' },
  },
  goat_clean: {
    display_name: 'GOAT clean',
    data: { description: 'Professionally cleaned & graded sneakers' },
  },
};
